export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/banner.4d408468-a6af94.png";